import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { GridModule } from '@progress/kendo-angular-grid';
import { DropDownsModule } from '@progress/kendo-angular-dropdowns';
import { HttpClientModule } from '@angular/common/http';
import { CgpModule } from '../../../../../src/app/shared/cgp.module';
import { LayoutModule } from '@progress/kendo-angular-layout';
import { CardGridModule } from '../../../../../src/app/shared/card-grid/card-grid.module';
import { IntlModule } from '@progress/kendo-angular-intl';
import { UploadModule } from '@progress/kendo-angular-upload';

/** COMPONENTS */
import { AdministrationComponent } from './administration.component';
import { ArchitectureComponent } from './architecture/architecture.component';
import { BaseGridComponent } from './base-grid/base-grid.component';
import { SmtComponent } from './smt/smt.component';
import { GatesComponent } from './gates/gates.component';
import { MBOMComponent } from './m-bom/m-bom.component';
import { ToolingOperatorInterfacesComponent } from './tooling-operator-interfaces/tooling-operator-interfaces.component';
import { RequestTypeComponent } from './request-type/request-type.component';
import { DeliverablesComponent } from './deliverables/deliverables.component';
import { AddInfoCategoryComponent } from './add-info-category/add-info-category.component';
import { CMEAreaComponent } from './cme-areas/cme-area.component';
import { StudyTitlesComponent } from './study-titles/study-titles.component';
import { TotalVehicleNumberComponent } from './total-vehicle-number/total-vehicle-number.component';
import { TrackingVehicleNumberComponent } from './tracking-vehicle-number/tracking-vehicle-number.component';
import { BannerComponent } from './banner/banner.component';
import { AreasComponent } from './areas/areas.component';
import { ProgramDetailsGaComponent } from './program-details-ga/program-details-ga.component';
import { ProgramDetailsBodyComponent } from './program-details-body/program-details-body.component';
import { DefaultNotificationContactsComponent } from './default-notification-contacts/default-notification-contacts.component';
import { HolidayScheduleComponent } from './holiday-schedule/holiday-schedule.component';

/** SERVICES */
import { AdministrationService } from './administration.service';
import {
    AddInfoCategoryService,
    ArchitectureService,
    AreaService,
    AuthorizationService,
    BannerService,
    BaseService,
    CMEAreaService,
    DeliverablesService,
    GateService,
    GlobalRegionService,
    HolidayScheduleService,
    MBOMService,
    PlantService,
    ProgramDetailsBodyService,
    ProgramDetailsGAService,
    ProgramService,
    RequestTypeService,
    SmtService,
    StudyTitlesService,
    ToolingOperatorService,
    TotalVehicleNumberService,
    TrackingVehicleNumberService,
    WorkOrderNotificationService,
    ZoneService,
} from '../ve.service';
import { AuthGuard } from '../../../auth.guard';
import { MatLegacyButtonModule as MatButtonModule } from '@angular/material/legacy-button';
import { MatIconModule } from '@angular/material/icon';
import { MatLegacyCardModule as MatCardModule } from '@angular/material/legacy-card';
import { MatLegacyDialogModule as MatDialogModule } from '@angular/material/legacy-dialog';

/** ROUTES */
export const administrationRoutes = {
    path: 'Administration',
    component: AdministrationComponent,
    canActivate: [AuthGuard],
    data: {
        expectedRoles: ['Administrator']
    },
    children:
        [
            {
                path: 'Architecture',
                component: ArchitectureComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'SMT',
                component: SmtComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Gate',
                component: GatesComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'mBOM',
                component: MBOMComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Tooling-Operator-Interfaces',
                component: ToolingOperatorInterfacesComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Request-Type',
                component: RequestTypeComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Deliverables',
                component: DeliverablesComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Additional-Information-Category',
                component: AddInfoCategoryComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'CME-Area',
                component: CMEAreaComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Study-Titles',
                component: StudyTitlesComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Total-Vehicle-Number',
                component: TotalVehicleNumberComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Tracking-Vehicle-Number',
                component: TrackingVehicleNumberComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Banner',
                component: BannerComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Areas',
                component: AreasComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Ga-Program-Details',
                component: ProgramDetailsGaComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Body-Program-Details',
                component: ProgramDetailsBodyComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Default-Notification-Contacts',
                component: DefaultNotificationContactsComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            },
            {
                path: 'Holiday-Schedule',
                component: HolidayScheduleComponent,
                canActivate: [AuthGuard],
                data: {
                    expectedRoles: ['Administrator']
                },
            }
        ]
};

/** MODULES */
@NgModule({
    imports: [
        CardGridModule,
        CgpModule,
        CommonModule,
        DropDownsModule,
        FormsModule,
        GridModule,
        HttpClientModule,
        IntlModule,
        LayoutModule,
        MatButtonModule,
        MatCardModule,
        MatDialogModule,
        MatIconModule,
        ReactiveFormsModule,
        RouterModule,
        UploadModule,
    ],
    declarations: [
        AddInfoCategoryComponent,
        AdministrationComponent,
        ArchitectureComponent,
        AreasComponent,
        BannerComponent,
        BaseGridComponent,
        CMEAreaComponent,
        DefaultNotificationContactsComponent,
        DeliverablesComponent,
        GatesComponent,
        HolidayScheduleComponent,
        MBOMComponent,
        ProgramDetailsBodyComponent,
        ProgramDetailsGaComponent,
        RequestTypeComponent,
        SmtComponent,
        StudyTitlesComponent,
        ToolingOperatorInterfacesComponent,
        TotalVehicleNumberComponent,
        TrackingVehicleNumberComponent,
    ],
    providers: [
        AddInfoCategoryService,
        AdministrationService,
        ArchitectureService,
        AreaService,
        AuthorizationService,
        BannerService,
        BaseService,
        CMEAreaService,
        DeliverablesService,
        GateService,
        GlobalRegionService,
        HolidayScheduleService,
        MBOMService,
        PlantService,
        ProgramDetailsBodyService,
        ProgramDetailsGAService,
        ProgramService,
        RequestTypeService,
        SmtService,
        StudyTitlesService,
        ToolingOperatorService,
        TotalVehicleNumberService,
        TrackingVehicleNumberService,
        WorkOrderNotificationService,
        ZoneService,
    ]
})

export class AdministrationModule { }
